import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "0c065ed8-55d4-4571-81a3-b49567b89da6",
  title: "Hal Higdon: Novice 1",
  raceType: "Marathon",
  units: "miles",
  workouts: [
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles",
      totalDistance: 6,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "7 miles",
      totalDistance: 7,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles",
      totalDistance: 5,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "9 miles",
      totalDistance: 9,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "10 miles",
      totalDistance: 10,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "7 miles",
      totalDistance: 7,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "13.1 miles Half Marathon",
      totalDistance: 13.1,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "10 miles",
      totalDistance: 10,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "15 miles",
      totalDistance: 15,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "16 miles",
      totalDistance: 16,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "9 miles run",
      totalDistance: 9,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "18 miles",
      totalDistance: 18,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "9 miles run",
      totalDistance: 9,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "14 miles",
      totalDistance: 14,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "10 miles run",
      totalDistance: 10,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "20 miles",
      totalDistance: 20,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "8 miles",
      totalDistance: 8,
    },
    { description: "Cross", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "2 miles run",
      totalDistance: 2,
    },
    { description: "Rest", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    { description: "Marathon", totalDistance: 26.2 },
  ],
} as BuiltInPlan;